<ng-container *ngIf="showSelector">
  <atlas-item icon="apps" interactable>
    <atlas-menu id="atlas-navbar__center-selector">
      <div>
        <ng-container *ngFor="let navItem of centerData">
          <atlas-menu-item
            *ngIf="navItem.centerId !== serviceProviderId"
            [label]="navItem.name"
            [url]="navItem.entryUrl"
          ></atlas-menu-item>
        </ng-container>
      </div>
    </atlas-menu>
  </atlas-item>
</ng-container>
